import { render, staticRenderFns } from "./MeasurementsSummary.vue?vue&type=template&id=6ca67b89"
import script from "./MeasurementsSummary.vue?vue&type=script&lang=ts"
export * from "./MeasurementsSummary.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports